export default {
  id: "hourOfDayPerformance",
  name: "",
  description: "",
  report: {
    name: "Hour of Day Performance",
    template: "hour-of-day",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: ["Sale.sale_hour_of_day"],
      measures: ["Sale.total_revenue", "Sale.total_gross_profit"],
      sort: {
        direction: "asc",
        by: "Sale.sale_hour_of_day",
      },
      filters: [],
      compare: false,
      limit: "24",
      rowTotals: false,
      stacked: false,
      points: true,
      colorTheme: "default",
    },
  },
};
